/* eslint-disable */

import { fork, all, takeEvery, put } from 'redux-saga/effects';
import _ from 'lodash';
import {
  GET_LISTS,
  GET_LISTS_SUCCESS,
  GET_LISTS_FAIL,
  GET_CATEGORIES,
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORIES_FAIL,
} from './redux';
import Request from 'client/utils/xhrWrapper';

export function* getLists() {
  yield takeEvery(GET_LISTS, function* (data) : any {
    try {
      const tagID = _.get(data, ['data', 'id']) || '1';
      const catID = _.get(data, ['data', 'cat_id']);
      const nextPageLink = _.get(data, ['data', 'nextPageLink']);
      const response = yield Request.get(nextPageLink ? nextPageLink : `video/video/list/tagid/${tagID}${catID ? `/catid/${catID}` : ''}`);
      if (_.get(response, ['data']) && _.get(response, ['data']).length > 0) {
        yield put({
          type: GET_LISTS_SUCCESS,
          data: {
            list_data: _.get(response, ['data']),
            list_info: _.get(response, ['meta']),
            nextPageLink: _.get(response, ['links', 'next']),
          },
        });
      } else {
        if (_.get(response, ['data']).length === 0) {
          yield put({
            type: GET_LISTS_FAIL,
            data: {
              status: 'no_data',
            }
          });
        } else {
          yield put({ type: GET_LISTS_FAIL, data: {} });
        }
      }
    } catch (error) {
      yield put({ type: GET_LISTS_FAIL, data: error });
    }
  });
}

export function* getCategories() {
  yield takeEvery(GET_CATEGORIES, function* (data) : any {
    try {
      const response = yield Request.get('video/video/categories');
      if (_.get(response, ['data'])) {
        yield put({
          type: GET_CATEGORIES_SUCCESS,
          data: _.get(response, ['data']),
        });
      } else {
        yield put({ type: GET_CATEGORIES_FAIL, data: {} });
      }
    } catch (error) {
      yield put({ type: GET_CATEGORIES_FAIL, data: error });
    }
  });
}

export default function* () {
  yield all([
    fork(getLists),
    fork(getCategories),
  ]);
}
